import React, { Component } from "react";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

class EntriesSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
    };
  }

  changeSize(event) {
    console.log(event.target.value);
    this.props.setSize(event.target.value);
    this.props.setPage(1);
    this.props.getEntries(this.state.user, event.target.value, 1, ...(this.props.extraArgs || []));
  }

  // render() {
  //   return (
  //     <React.Fragment>
  //       <label className="mr-2">{this.props.label}</label>
  //       <select
  //         className="custom-select custom-select-sm w-25"
  //         onChange={(event) => this.changeSize(event)}
  //       >
  //         <option selected={this.props.size === 5} value="5">
  //           5
  //         </option>
  //         <option selected={this.props.size === 10} value="10">
  //           10
  //         </option>
  //         <option selected={this.props.size === 20} value="20">
  //           20
  //         </option>
  //         <option selected={this.props.size === 50} value="50">
  //           50
  //         </option>
  //         <option selected={this.props.size === 100} value="100">
  //           100
  //         </option>
  //       </select>
  //     </React.Fragment>
  //   );
  // }
  render() {
    return (
      <React.Fragment>
        <label className="mr-2">{this.props.label}</label>
        <select
          className="custom-select custom-select-sm w-25"
          value={this.props.size} // utilizamos la propiedad value para establecer el valor actual
          onChange={(event) => this.changeSize(event)}
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </React.Fragment>
    );
  }
}
export default EntriesSelector;
